import debounce from "debounce";
import transitionend from "../../util/transitionend";

function CheckoutNav() {
    this.checkout_form = jQuery('form.checkout');

    this.validate_customer_details = document.getElementById('validate-customer-details');
    this.back_customer_details = document.querySelector('.back-customer-details');
    this.steps_container = document.querySelector('.checkout__steps-inner');

    this.customer_details_el = document.querySelector('.checkout__step--customer');
    this.payment_el = document.querySelector('.checkout__step--payment');
    this.place_order_btn = document.getElementById('place_order');

    var that = this;
    that.init();
}

CheckoutNav.prototype.init = function() {
    var that = this;

    var billingFirstName = jQuery('#billing_first_name');
    var billingLastName = jQuery('#billing_last_name');
    var shippingFirstName = jQuery('#shipping_first_name');
    var shippingLastName = jQuery('#shipping_last_name');

    // First letter uppercase
    var elementFirstUpper = function(el) {
        el.keyup(function() {
            var str = el.val().toLowerCase();

            var spart = str.split(" ");
            for ( var i = 0; i < spart.length; i++ )
            {
                var j = spart[i].charAt(0).toUpperCase();
                spart[i] = j + spart[i].substr(1);
            }
            el.val(spart.join(" "));
        });
    };

    elementFirstUpper(billingFirstName);
    elementFirstUpper(billingLastName);
    elementFirstUpper(shippingFirstName);
    elementFirstUpper(shippingLastName);


    jQuery('form.checkout').submit(function(event){
        event.preventDefault();
        that.checkPasswordBeforePlaceOrder(event);
    });

    jQuery('#account_password').after("<span id='password_strength' class='woocommerce-password-strength'></span>");
    jQuery("#account_password").keyup(function(e){
        window.checkPasswordStrength(jQuery(this),jQuery('#password_strength'), [], jQuery('#place_order'), true );
    });

    document.addEventListener('updated-checkout', function() {
        that.checkBillingShippingFields();
    });

    // if not mobile
    if (this.back_customer_details !== null && this.validate_customer_details !== null) {

        this.back_customer_details.addEventListener('click', function(){
            that.onBackClick();
            });

        this.validate_customer_details.addEventListener('click', function(){
            that.onNextClick();
        });

        // prevent tabbing to next step
        jQuery("form.checkout input").keydown(function(e){

            that.ship_to_different_address = document.querySelector('#ship-to-different-address-checkbox');
            that.create_account = document.querySelector('div.create-account');

            if ((e.which || e.keyCode || e.charCode) == 9) {

                if (that.ship_to_different_address.checked) {
                    that.last_customer_input = jQuery('#shipping_postcode');
                }
                else {
                    that.last_customer_input = jQuery('#billing_email');
                    if (document.getElementById('billing_email_confirm')) {
                        that.last_customer_input = jQuery('#billing_email_confirm');
                    }
                    if (that.create_account && that.create_account.style.display != 'none') {
                        that.last_customer_input = jQuery('#account_password');
                    }
                }

                if (jQuery(this)[0] == that.last_customer_input[0]) {
                    e.preventDefault();
                }
            }

        });

    }

};

CheckoutNav.prototype.checkPasswordBeforePlaceOrder = function(event) {
    var errors = false;
    this.create_account = document.querySelector('div.create-account');

    if (this.create_account && this.create_account.style.display != 'none') { // if account fields showing
        this.password = document.getElementById('account_password').value;
        if (!window.password_meets_min_reqs(this.password) && window.new_password_strength < 2) {
            errors = true;
            jQuery('#account_password_field').addClass('woocommerce-invalid');
        }
    }

    if (errors) {
        event.preventDefault();
        jQuery('html, body').animate({
            scrollTop: jQuery(".woocommerce-invalid").offset().top - 100
        }, 500);
    }

}

CheckoutNav.prototype.validateField = function(field) {

    // there might be a better way of doing this, trigger woocommerce validation on input to verify class?

    var input = field.querySelector('input');

    if (input && input.value != "" && field.classList.contains('woocommerce-invalid')) {
        field.classList.remove('woocommerce-invalid');
    }

    if (
        (input && input.value == "")
        || field.classList.contains('woocommerce-invalid')
        )
    {
        field.classList.add('woocommerce-invalid');
        return true;
    }

    return false;

}

CheckoutNav.prototype.checkBillingShippingFields = function() {

    // can change after page load
    this.required_billing_fields = document.querySelectorAll('.woocommerce-billing-fields .validate-required');

    this.ship_to_different_address = document.querySelector('#ship-to-different-address-checkbox');
    this.required_shipping_fields = document.querySelectorAll('.woocommerce-shipping-fields .validate-required');

    var that = this;
    var errors = false;

    for (var i = 0; i < this.required_billing_fields.length; i++) {
        var field = this.required_billing_fields[i];
        if ( this.validateField(field) ) {
            errors = true;
        }
    }

    if (this.ship_to_different_address.checked) {
        for (var i = 0; i < this.required_shipping_fields.length; i++) {
            var field = this.required_shipping_fields[i];
            if ( this.validateField(field) ) {
                errors = true;
            }
        }
    }

    return errors;
}

CheckoutNav.prototype.onNextClick = function() {

    this.create_account = document.querySelector('div.create-account');
    this.password = document.getElementById('account_password');
    if (this.password) this.password = this.password.value;

    this.billing_email_value = document.getElementById('billing_email').value;
    // get confirm value if field is there (ie. not logged in)
    if (document.getElementById('billing_email_confirm')) {
        this.billing_email_confirm_value = document.getElementById('billing_email_confirm').value;
    }
    else {
        this.billing_email_confirm_value = this.billing_email_value;
    }

    var that = this;
    var errors = this.checkBillingShippingFields();

    if (this.create_account && this.create_account.style.display != 'none') { // if account fields showing
        if (!window.password_meets_min_reqs(this.password) && window.new_password_strength < 2) {
            errors = true;
            jQuery('#account_password_field').addClass('woocommerce-invalid');
        }
    }

    if (this.billing_email_value != this.billing_email_confirm_value) {
        errors = true;
        document.getElementById('billing_email_confirm_field').classList.add('woocommerce-invalid');
    }

    if (errors) {
        jQuery('html, body').animate({
            scrollTop: jQuery(".woocommerce-invalid").offset().top - 100
        }, 500);
    }

    if (!errors) {

        that.validate_customer_details.classList.add('waiting');
        var post_data = jQuery('form.woocommerce-checkout').serializeArray();

        post_data = post_data.filter(this.checkIfFirstStepField);

        post_data.push({name: 'do_not_complete', value: 1});

        jQuery.ajax({
            type: "POST",
            url: "?wc-ajax=checkout",
            data: post_data
        })
        .done(function (response) {

			const responseType = typeof response;
			var newResponseType = false;

			if(responseType == 'object') {
				newResponseType = true;
			} else {
				response = JSON.parse(response);
			}

			console.log(response);
			console.log(responseType);

            that.validate_customer_details.classList.remove('waiting');

            if (response.status == "success") {

                that.steps_container.classList.add('show-payment');

                jQuery('.woocommerce-NoticeGroup-checkout').remove();

                jQuery('html, body').animate({
                    scrollTop: jQuery(".checkout__steps").offset().top - 100
                }, 500);

            }
            else {

				var html = "";
				html += "<div class='woocommerce-NoticeGroup woocommerce-NoticeGroup-checkout'>";

				if(newResponseType) {
					if(response.messages) {
						html += response.messages;
					}
				} else {
					html += "<ul class='woocommerce-error' role='alert'>";
					for (var i = 0; i < response.errors.length; i++) {
						html += "<li>" + response.errors[i] + "</li>";
					}
					html += "</ul>";
				}

                html += "</div>";

                jQuery('form.woocommerce-checkout').prepend(html);

                jQuery('html, body').animate({
                    scrollTop: jQuery(".woocommerce-NoticeGroup-checkout").offset().top - 100
                }, 500);

            }
        });

    }
}

CheckoutNav.prototype.checkIfFirstStepField = function(field) {

    if (field.name == 'woocommerce-process-checkout-nonce' || field.name == '_wp_http_referer') {
        return true;
    }

    if (field.name.indexOf('billing_') !== -1 || field.name.indexOf('shipping_') !== -1) {
        return true;
    }

    return false;

}

CheckoutNav.prototype.onBackClick = function() {
    var that = this;
    // console.log('onbackclick');
    this.steps_container.classList.remove('show-payment');
    jQuery('html, body').animate({
        scrollTop: jQuery(".checkout__steps").offset().top - 100
    }, 500);
}

export default CheckoutNav;



// WEBPACK FOOTER //
// ./js/components/checkout-nav/index.js